import { isAllowed } from '@ion/api/Apollo/allower';
import permissions from '@ion/api/Apollo/permissions';

export default function isAllowedToOverrideOrganization() {
  return isAllowed(permissions.overrideOrganization);
}
